module.exports = __webpack_public_path__ + "static/img/quizz_foot_logo.46684ac9.png";